module.exports = __webpack_public_path__ + "static/media/bs.8d95c3b2.svg";